import React, { useState, useEffect } from 'react';
import { Button, Modal, Table, Spinner, Form, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import './SendRequestPage.css';

const SendRequestPage = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [currentRequest, setCurrentRequest] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);
  const [loggedInUser, setLoggedInUser] = useState(null); // State for logged-in user
  const [products, setProducts] = useState([]); // State for products
  const [formData, setFormData] = useState({
    
    name: '',
    phone: '',
    email: '',
    productType: 'Pipe',
    quantity: '',
    price: '',
    priority: '',
    tinNo: '',
    address: '',
    unit: '',
    dueDate: '',
  });
  const [formError, setFormError] = useState('');

  // Fetch logged-in user info
  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await axios.get('https://agpipefitting.org.et/api/user', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        setLoggedInUser(response.data);
      } catch (error) {
        console.error('Error fetching logged-in user info:', error);
      }
    };

    fetchUserInfo();
  }, []);

  // Fetch product data
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://agpipefitting.org.et/api/products');
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchProducts();
  }, []);

  // Fetch requests for the logged-in user
  const fetchRequests = async () => {
    setLoading(true);
    try {
      const response = await axios.get('https://agpipefitting.org.et/api/requests', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setRequests(response.data);
    } catch (error) {
      console.error('Error fetching requests:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (loggedInUser) {
      fetchRequests();
    }
  }, [loggedInUser]);

  const handleViewDetails = (request) => {
    setCurrentRequest(request);
    setShowDetailsModal(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Auto-update price when productType changes
    if (name === 'productType') {
      const selectedProduct = products.find((product) => product.type === value);
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
        price: selectedProduct ? selectedProduct.price : '',
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const validateForm = () => {
    const { name, phone, email, quantity, price, dueDate } = formData;
    if (!name || !phone || !email || !quantity || !price || !dueDate) {
      setFormError('Please fill in all the required fields.');
      return false;
    }
    setFormError('');
    return true;
  };

  const handleSaveRequest = async () => {
    if (!validateForm()) return;

    const totalAmount = formData.quantity * formData.price;
    const vat = totalAmount * 0.15;
    const totalWithVat = totalAmount + vat;

    const invoice = {
      ...formData,
      totalAmount,
      vat,
      totalWithVat,
      invoiceDate: new Date().toLocaleDateString(),
    };

    setLoading(true);
    try {
      await axios.post('https://agpipefitting.org.et/api/requests', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setInvoiceData(invoice);
      setShowInvoiceModal(true);
      setShowModal(false);
      fetchRequests();
    } catch (error) {
      console.error('Error saving request:', error);
      alert('There was an error saving the request. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteRequest = async (id) => {
    try {
      await axios.delete(`https://agpipefitting.org.et/api/requests/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      fetchRequests();
    } catch (error) {
      console.error('Error deleting request:', error);
      alert('There was an error deleting the request.');
    }
  };

  const handlePrint = () => {
    const content = document.getElementById('invoice-content');
    const printWindow = window.open('', '_blank');
    printWindow.document.write(content.innerHTML);
    printWindow.document.close();
    printWindow.print();
  };


  return (
    <div className="container mt-5">
      <h2>Order Request Management</h2>
      <Button variant="primary" onClick={() => setShowModal(true)} className="mb-3">
        Add New Request
      </Button>

      {/* Modal for Adding/Editing Request */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col>
              <Form.Group controlId="formName">
  <Form.Label>Name</Form.Label>
  <Form.Control
    type="text"
    name="name"
    value={formData.name}
    onChange={handleInputChange}
    placeholder="Enter your name"
    disabled={!!formData.name} // Disable the field if the name is pre-filled
  />
</Form.Group>

              </Col>
              <Col>
                <Form.Group controlId="phone">
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Enter your phone"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Enter your email"
              />
            </Form.Group>
            <Form.Group>
                  <Form.Label>Product Type</Form.Label>
                  <Form.Control
                    as="select"
                    name="productType"
                    value={formData.productType}
                    onChange={handleInputChange}
                  >
                    <option value="">Select a product</option>
                    {products.map((product) => (
                      <option key={product.id} value={product.type}>
                        {product.type}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
            <Row>
              <Col>
                <Form.Group controlId="quantity">
                  <Form.Label>Quantity</Form.Label>
                  <Form.Control
                    type="number"
                    name="quantity"
                    value={formData.quantity}
                    onChange={handleInputChange}
                    placeholder="Enter quantity"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="price">
                  <Form.Label>Price</Form.Label>
                  <Form.Control
                    type="number"
                    name="price"
                    value={formData.price}
                    onChange={handleInputChange}
                    placeholder="Enter price"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group controlId="priority">
                  <Form.Label>Priority</Form.Label>
                  <Form.Control
                    type="text"
                    name="priority"
                    value={formData.priority}
                    onChange={handleInputChange}
                    placeholder="Enter priority"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="tinNo">
                  <Form.Label>TIN No</Form.Label>
                  <Form.Control
                    type="text"
                    name="tinNo"
                    value={formData.tinNo}
                    onChange={handleInputChange}
                    placeholder="Enter TIN No"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group controlId="address">
              <Form.Label>Address</Form.Label>
              <Form.Control
                type="text"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                placeholder="Enter address"
              />
            </Form.Group>
            <Row>
              <Col>
                <Form.Group controlId="unit">
                  <Form.Label>Unit</Form.Label>
                  <Form.Control
                    type="text"
                    name="unit"
                    value={formData.unit}
                    onChange={handleInputChange}
                    placeholder="Enter unit"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="dueDate">
                  <Form.Label>Due Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="dueDate"
                    value={formData.dueDate}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="text-danger">{formError}</div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSaveRequest}>
            Save Request
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Request List */}
      <div className="mt-4">
        <h4>Request List</h4>
        {loading ? (
          <Spinner animation="border" />
        ) : (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Product Type</th>
                <th>Priority</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((request) => (
                <tr key={request.id}>
                  <td>{request.name}</td>
                  <td>{request.phone}</td>
                  <td>{request.email}</td>
                  <td>{request.productType}</td>
                  <td>{request.priority}</td>
                  <td>
                    <Button
                      variant="info"
                      size="sm"
                      onClick={() => handleViewDetails(request)}
                    >
                      View Details
                    </Button>{' '}
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleDeleteRequest(request.id)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>

      {/* Modal for Viewing Request Details */}
      <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Request Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {currentRequest && (
            <div>
              <p><strong>Name:</strong> {currentRequest.name}</p>
              <p><strong>Phone:</strong> {currentRequest.phone}</p>
              <p><strong>Email:</strong> {currentRequest.email}</p>
              <p><strong>Product Type:</strong> {currentRequest.productType}</p>
              <p><strong>Priority:</strong> {currentRequest.priority}</p>
              <p><strong>Quantity:</strong> {currentRequest.quantity}</p>
              <p><strong>Price:</strong> {currentRequest.price}</p>
              <p><strong>Total:</strong> {currentRequest.totalAmount}</p>
              <p><strong>TIN No:</strong> {currentRequest.tinNo}</p>
              <p><strong>Address:</strong> {currentRequest.address}</p>
              <p><strong>Unit:</strong> {currentRequest.unit}</p>
              <p><strong>Due Date:</strong> {currentRequest.dueDate}</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for Proforma Invoice */}
<Modal show={showInvoiceModal} onHide={() => setShowInvoiceModal(false)} size="lg" centered>
  <Modal.Header closeButton className="modal-header">
    <Modal.Title>Proforma Invoice</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {invoiceData && (
      <div className="invoice-container">
        {/* Company Information and Payment Details Section */}
        <div className="company-payment-row">
          {/* Company Information */}
          <div className="company-info">
            <h4>Company Information</h4>
            <p><strong>Company Address:</strong> Company Address</p>
            <p><strong>Phone:</strong> Company Phone</p>
            <p><strong>Email:</strong> company@example.com</p>
          </div>

          {/* Payment Details */}
          <div className="payment-details">
            <h5>Payment Details</h5>
            <p><strong>Commercial Bank of Ethiopia:</strong> 1000145742653</p>
            <p><strong>Abay Bank:</strong> 2012111008152013</p>
            <p><strong>Abysinia Bank:</strong> 16790273</p>
          </div>
        </div>

        {/* Customer and Invoice Information */}
        <div className="customer-info">
          <h5>Client's Name: {invoiceData.name}</h5>
          <p>Date: {invoiceData.invoiceDate}</p>
          <p>TIN No: {invoiceData.tinNo}</p>
        </div>

        {/* Product Table */}
        <div className="product-table">
          <table className="table">
            <thead>
              <tr>
                <th>S/N</th>
                <th>Product Description</th>
                <th>Product Code</th>
                <th>Unit</th>
                <th>Quantity</th>
                <th>Unit Price (Birr)</th>
                <th>Total Price (Birr)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>{invoiceData.productType}</td>
                <td>{invoiceData.productCode}</td>
                <td>{invoiceData.unit}</td>
                <td>{invoiceData.quantity}</td>
                <td>{invoiceData.price}</td>
                <td>{invoiceData.totalAmount}</td>
              </tr>
            </tbody>
          </table>

          <div className="invoice-summary">
            <div className="summary-item">
              <strong>Sum:</strong> {invoiceData.subtotal} Birr
            </div>
            <div className="summary-item">
              <strong>VAT (15%):</strong> {invoiceData.vat} Birr
            </div>
            <div className="summary-item">
              <strong>Total with VAT:</strong> {invoiceData.totalWithVat} Birr
            </div>
          </div>
        </div>
      </div>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowInvoiceModal(false)} className="btn-close">
      Close
    </Button>
    <Button variant="primary" onClick={handlePrint}>Print</Button>

  </Modal.Footer>
</Modal>

    </div>
  );
};

export default SendRequestPage;
